import { combineReducers } from 'redux-immutable';

import translation from './translation.duck';

export default combineReducers({
  translation
});
